import {connect} from 'react-redux';
import TournamentSearch from './TournamentSearch.jsx';
import {
  handleTournamentSearchEnterKeyPress,
  handleTournamentSearch
} from './actions';

import {
  setSearchTournamentValue
  } from './actionTypes';
const mapStateToProps = state => ({
  searchValue: state.tournament.tournamentList.searchValue
});

const mapDispatchToProps = dispatch => ({
  onSearchEnterKeyPress: event => dispatch(handleTournamentSearchEnterKeyPress(event)),
  onSearchClick: () => dispatch(handleTournamentSearch()),
  onSearchValueChange: searchValue => dispatch(setSearchTournamentValue(searchValue))
});

export default connect(mapStateToProps, mapDispatchToProps)(TournamentSearch);



// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/TournamentSearchContainer.jsx